import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

import { HeaderBar, Icon } from "components";
import Toast from "components/UnitsView/components/Toast";
import { getFontFamily } from "slices/property-slice/index";

const HeaderBarComp = ({ children, title, onBackButtonClick, isVisible, setIsVisible }) => {
  const fontFamily = useSelector(getFontFamily);

  return (
    <div className="hayley-h-full hayley-w-full hayley-items-center hayley-justify-center hayley-bg-secondary/80 sm:hayley-p-8">
      <div className="hayley-h-full hayley-w-full hayley-bg-white">
        {title == "Available Units" ? (
          <>
            <HeaderBar />
            <div className="hayley-flex hayley-flex-wrap hayley-px-6">
              <div
                data-testid="available_units_back_button"
                className={`hayley-flex hayley-items-center hayley-gap-x-3 hayley-py-5 hover:hayley-cursor-pointer`}
                onClick={onBackButtonClick}
              >
                <Icon iconType="LeftArrow" classes="hayley-h-[18px] hayley-w-[18px] hayley-text-inherit" />
                <Box
                  className="hayley-custom hayley-select-none hayley-text-lg hayley-font-semibold"
                  sx={{ "&.hayley-custom": { fontFamily: `${fontFamily} !important` } }}
                  data-testid="available_units_title"
                >
                  {title}
                </Box>
              </div>
              <Toast isVisible={isVisible} setIsVisible={setIsVisible} />
            </div>
            <div className="hayley-flex hayley-h-[calc(100dvh-97px)] hayley-w-full hayley-flex-col hayley-space-y-3 hayley-overflow-hidden hayley-px-4 sm:hayley-h-[calc(100dvh-156px)] sm:hayley-w-[calc(100dvw-64px)]">
              {children}
            </div>
          </>
        ) : (
          <>
            <HeaderBar title={title} onBackButtonClick={onBackButtonClick} />
            <div className="hayley-mt-3 hayley-flex hayley-h-[calc(100dvh-97px)] hayley-w-full hayley-flex-col hayley-space-y-3 hayley-overflow-hidden hayley-px-4 sm:hayley-h-[calc(100dvh-156px)] sm:hayley-w-[calc(100dvw-64px)]">
              {children}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderBarComp;
